export const formatTime = (date: Date | string) => {
  const formatter = new Intl.DateTimeFormat('cs-CZ', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })

  return formatter.format(new Date(date))
}

export const formatTimeShort = (date: Date | string) => {
  const formatter = new Intl.DateTimeFormat('cs-CZ', {
    hour: 'numeric',
    minute: 'numeric',
  })

  return formatter.format(new Date(date))
}
